<template>
  <div>
    <div class="container">
    <h1>{{$t('Global.Merkliste.Headline')}}</h1>
      <p class="mt-5 text-left">{{$t('Global.Merkliste.Info')}}</p>
    </div>
    <div class="container">
      <router-link :to="{ name: 'pdf', params:{Angebote: Angebote}}"  class="nav-links">
        <button type="button" class="btn btn-outline-danger waves-effect">PDF Download</button>
      </router-link>
    </div>
    <div class="list">
        <div class="container">
          <div class="row">
            <div class="col-12">
            <Angebot :Angebote="Angebote" :user="User" :isOnMerkliste="true" :isMerklistenView="true" class="merklisten__item"/>
            </div>
          </div>
        </div>
    </div>

  </div>
</template>

<script>
import Angebot from "@/components/angebot/mieter/Angebote";
import AngebotService from "@/services/AngebotService";
import jsPDF from 'jspdf';
import html2canvas from "html2canvas"
import { bus } from '@/main';
import { mapGetters } from 'vuex'

export default {
  name: "Merkliste",
  components: {
    Angebot,
  },
  data() {
    return {
      Angebote: {},
      User: Object,
      Texte: "",
    };
  },
  methods:{
      showModal(id){
        this.$refs.modal.showIt(id)
      },
      getMerkliste(){
        if(this.userObject.type == 0){

          AngebotService.getMerkliste(this.User.persistence_object_identifier)
                  .then(response => {
                    let angebotData = response.data;
                    let filterd = angebotData;
                    this.Angebote = filterd; // <--- set the events when returned

                  })
                  .catch(error => {
                    console.log("There was an error:", error.response);
                  });

        } else {
          AngebotService.getMerkliste(this.User.account)
                  .then(response => {
                    let angebotData = response.data;
                    let filterd = angebotData;
                    //this.Angebote = angebotData.filter(a => a.aktiv == 1); // <--- set the events when returned
                    this.Angebote = filterd; // <--- set the events when returned

                  })
                  .catch(error => {
                    console.log("There was an error:", error.response);
                  });
        }
      }
  },
  created() {
    let user = this.$store.getters.userObject;
    this.User = user;
    this.Texte = this.$locales.Texte;
    this.getMerkliste();
    bus.$on('merklisteChange', (data) => {
      this.getMerkliste();
    })
  },
  computed:{
    ...mapGetters([
      'userObject',

    ])
  },


};
</script>
<style lang="scss" scoped>
  .gen{
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: white;
    color: black;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    transition: all 0.25s ease-out;
    &.active{
      opacity: 1;
      visibility: visible;
      pointer-events: all;
    }
  }
</style>